// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {   
        id: 1,
        url: 'https://cdn.pixabay.com/photo/2016/10/11/12/36/massage-therapy-1731456_960_720.jpg',
        alt: "deux petites serviettes enroulée sur une assiette avec des pétales de fleurs dans un décor de type zen"
    },
    {
        id: 2,
        url: 'https://cdn.pixabay.com/photo/2020/04/16/13/36/massage-5050641_960_720.jpg',
        alt: "salle de massage avec une table à masser couverte d'un drap blanc, dans un décor zen, clair, avec du bois sur les murs et deux grands miroirs"
    },
    {
        id: 3,
        url: 'https://cdn.pixabay.com/photo/2020/04/22/16/07/reception-5078879_960_720.jpg',
        alt: "salle de massage avec une table à masser couverte d'un drap blanc, dans un décor moderne, les murs sont clair et violet avec un grand miroir"
    },
    {
        id: 4,
        url: 'https://cdn.pixabay.com/photo/2017/08/07/22/13/spa-2608450_960_720.jpg',
        alt: "décoration zen avec deux petites serviettes enroulés osé sur un table, une petite brosse et une coupelle transparente rempli d'huile de massage sont devant les serviettes",
    },
    {   
        id: 5,
        url: 'https://cdn.pixabay.com/photo/2020/08/30/14/53/massage-5529798_960_720.jpg',
        alt: "salle de massage avec deux femmes qui massent chacunes d'elle deux autres femmes positionné sur le ventre sur une table de massage, dans une décoration moderne, clair"
    },
]